import { styled, css } from "styled-components";
import theme from "styled-theming";

import Link from "components/Link";
import { styleBodyM } from "style/components/Typography";
import { MQ } from "style/mediaQueries";

const textColor = theme("theme", {
    default: "--text-on-neutral-primary",
    white: "--text-on-neutral-primary",
    lightgray: "--text-on-neutral-primary",
    blue: "--text-on-blue-primary",
    cyan: "--text-on-cyan-primary",
});

const textColorDisabled = theme("theme", {
    default: "--text-on-neutral-disabled",
    white: "--text-on-neutral-disabled",
    lightgray: "--text-on-neutral-disabled",
    blue: "--text-on-blue-disabled",
    cyan: "--text-on-cyan-disabled",
});

const textColorSelected = theme("theme", {
    default: "--text-on-blue-primary",
    white: "--text-on-blue-primary",
    lightgray: "--text-on-blue-primary",
    blue: "--text-on-cyan-primary",
    cyan: "--text-on-blue-primary",
});

const borderColor = theme("theme", {
    default: "--filter-on-neutral-default-border",
    white: "--filter-on-neutral-default-border",
    lightgray: "--filter-on-neutral-default-border",
    blue: "--filter-on-blue-default-border",
    cyan: "--filter-on-cyan-default-border",
});

const borderColorDisabled = theme("theme", {
    default: "--filter-on-neutral-disabled-border",
    white: "--filter-on-neutral-disabled-border",
    lightgray: "--filter-on-neutral-disabled-border",
    blue: "--filter-on-blue-disabled-border",
    cyan: "--filter-on-cyan-disabled-border",
});

const borderColorHover = theme("theme", {
    default: "--filter-on-neutral-hover-border",
    white: "--filter-on-neutral-hover-border",
    lightgray: "--filter-on-neutral-hover-border",
    blue: "--filter-on-blue-hover-border",
    cyan: "--filter-on-cyan-hover-border",
});

const borderColorSelected = theme("theme", {
    default: "--filter-on-neutral-selected",
    white: "--filter-on-neutral-selected",
    lightgray: "--filter-on-neutral-selected",
    blue: "--filter-on-blue-selected",
    cyan: "--filter-on-cyan-selected",
});

const filterStyle = css<StyledLinkProps>`
    ${styleBodyM};
    background-color: transparent;
    border: 1px solid var(${borderColor});
    border-radius: 0.25rem;
    color: var(${textColor});
    display: inline-block;
    padding: 0.1875rem 0.375rem 0.125rem;
    transition: all 0.2s ease-in-out;

    svg,
    span {
        color: var(${textColor});
        display: block;
        transition: inherit;
    }

    svg {
        display: inline-block;
        margin-right: 0.4375rem;
    }

    ${MQ.FROM_M} {
        padding: 0.375rem 0.875rem;
    }

    &:hover {
        border-color: var(${borderColorHover});
    }

    &:focus-visible {
        outline: 7px solid var(--filter-focus);
        outline-offset: 0;
    }

    ${(props) =>
        props.disabled &&
        css`
            border-color: var(${borderColorDisabled});
            pointer-events: none;

            svg,
            span {
                color: var(${textColorDisabled});
            }
        `}

    ${(props) =>
        props.selected &&
        css`
            background-color: var(${borderColorSelected});
            border-color: var(${borderColorSelected});
            color: var(${textColorSelected});

            svg,
            span {
                color: var(${textColorSelected});
            }
        `}
`;

export const StyledLink = styled(Link)<StyledLinkProps>`
    ${filterStyle};
`;

export const StyledButton = styled.button<StyledLinkProps>`
    ${filterStyle};
`;

interface StyledLinkProps {
    selected?: boolean;
    disabled?: boolean;
}
